export default {
  allJobs: {},
  singleJob: {},
  appliedJob: [],
  offerJob: [],
  requestJob: [],
};
